import React, { FC } from 'react'

// Components
import { Button, Tooltip } from '@sketch/components'

// Local Components
import BillingInfoTable from '../BillingInfoTable'

// Types
import { BillingSeatsInfoFragment } from '@sketch/gql-types'

// Styles
import { StyledPluralize } from 'modules/workspace/modals/ChangeNextBillingCycleModal/ChangeNextBillingCycleModal.styles'

interface BillingForProps {
  seats: BillingSeatsInfoFragment
  onSeatScheduleChange: () => void
  isSubscriptionEnd: boolean
}

const scheduleSeatChangesCopy = 'Schedule Seat Changes…'

const CancelledSubscriptionButton: React.FC = () => {
  const tooltipText =
    'To schedule seat changes, please subscribe again. You can add new seats in the Members tab during the time left on your subscription.'

  return (
    <Tooltip
      placement="top"
      spacing="12px"
      content={
        <>
          <Tooltip.Title>Subscription is canceled</Tooltip.Title>
          <Tooltip.Body>{tooltipText}</Tooltip.Body>
        </>
      }
    >
      <Button variant="secondary" size="32" disabled>
        {scheduleSeatChangesCopy}
      </Button>
    </Tooltip>
  )
}

const BillingFor: FC<BillingForProps> = ({
  seats,
  onSeatScheduleChange,
  isSubscriptionEnd,
}) => {
  return (
    <BillingInfoTable.Row>
      <BillingInfoTable.HeadingCell>Billing For</BillingInfoTable.HeadingCell>
      <BillingInfoTable.Cell>
        <strong>
          <StyledPluralize
            singular="Editor Seat"
            plural="Editor Seats"
            count={seats.scheduledSeatsTotal || seats.currentSeatsTotal}
            showCount
          />
        </strong>
      </BillingInfoTable.Cell>
      <BillingInfoTable.Cell>
        {isSubscriptionEnd && <CancelledSubscriptionButton />}
        {!isSubscriptionEnd && (
          <Button variant="secondary" onClick={onSeatScheduleChange} size="32">
            {scheduleSeatChangesCopy}
          </Button>
        )}
      </BillingInfoTable.Cell>
    </BillingInfoTable.Row>
  )
}

export default BillingFor
